import { render, staticRenderFns } from "./UploadItemsModal.vue?vue&type=template&id=07ff23e1&"
import script from "./UploadItemsModal.vue?vue&type=script&lang=js&"
export * from "./UploadItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadItemsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports